// src/AES_MODE.ts
var AES_MODE = "AES-GCM";

export {
  AES_MODE
};
